import { t } from "@travily/i18n";
import { Illustration } from "@ui/components/Illustration";
import { RetroButton } from "@ui/components/RetroButton";

export interface ActionProps {
  label: string;
  onPress: () => void;
}

export interface ShowViewProps {
  title: string;
  description: string;
  primaryAction?: ActionProps;
  secondaryAction?: ActionProps;
}

function ActionButtons({ primaryAction, secondaryAction }: Pick<ShowViewProps, "primaryAction" | "secondaryAction">) {
  if (!primaryAction && !secondaryAction) return null;

  return (
    <>
      <div className="flex gap-4 md:hidden">
        {primaryAction && (
          <RetroButton color="yellow" onPress={primaryAction.onPress} size="40">
            {primaryAction.label}
          </RetroButton>
        )}
        {secondaryAction && (
          <RetroButton color="green" onPress={secondaryAction.onPress} size="40">
            {secondaryAction.label}
          </RetroButton>
        )}
      </div>
      <div className="hidden gap-6 md:flex">
        {primaryAction && (
          <RetroButton color="yellow" onPress={primaryAction.onPress} size="48">
            {primaryAction.label}
          </RetroButton>
        )}
        {secondaryAction && (
          <RetroButton color="green" onPress={secondaryAction.onPress} size="48">
            {secondaryAction.label}
          </RetroButton>
        )}
      </div>
    </>
  );
}

export function ShowView({ title, description, primaryAction, secondaryAction }: ShowViewProps) {
  return (
    <div className="flex flex-col items-center">
      <Illustration
        alt={t("components.views.errors.show.illustration_alt")}
        className="h-[201px] w-[280px] object-contain md:h-[360px] md:w-[500px]"
        name="error"
      />
      <div className="flex flex-col items-center gap-6 px-4 pt-6 text-center md:gap-7 md:px-0 md:pt-5">
        <div className="flex flex-col items-center gap-2">
          <h1 className="text-display-xs font-extrabold tracking-display-xs text-green-950 md:text-display-xl md:tracking-display-xl">
            {title}
          </h1>
          <p className="text-base tracking-base text-neutral-800 md:text-2xl md:tracking-2xl">{description}</p>
        </div>
        <ActionButtons primaryAction={primaryAction} secondaryAction={secondaryAction} />
      </div>
    </div>
  );
}
